
    var riot = require('riot')
    
riot.tag2('pricing', '<div if="{!window.location.search.match(/editmode/)}"> <hr> <div if="{!window.location.hash.match(/education|shopping|ecommerce|membership|web_apps|professional_services/)}"> <h3>Choose the sector closest to your requirements</h3> <div class="row"> <div class="col-xs-12 col-sm-6 col-md-4 form-group"><a href="#sector=education" onclick="{sectorchange}" class="btn btn-primary btn-block">Education</a></div> <div class="col-xs-12 col-sm-6 col-md-4 form-group"><a href="#sector=shopping" onclick="{sectorchange}" class="btn btn-primary btn-block">Shopping Centres</a></div> <div class="col-xs-12 col-sm-6 col-md-4 form-group"><a href="#sector=web_apps" onclick="{sectorchange}" class="btn btn-primary btn-block">Web Apps</a></div> <div class="col-xs-12 col-sm-6 col-md-4 form-group"><a href="#sector=ecommerce" onclick="{sectorchange}" class="btn btn-primary btn-block">Ecommerce</a></div> <div class="col-xs-12 col-sm-6 col-md-4 form-group"><a href="#sector=membership" onclick="{sectorchange}" class="btn btn-primary btn-block">Membership Organisations</a></div> <div class="col-xs-12 col-sm-6 col-md-4 form-group"><a href="#sector=professional_services" onclick="{sectorchange}" class="btn btn-primary btn-block">Professional Services</a></div> </div> </div> <form method="post" action="/duocms/api/formsend"> <input type="hidden" name="_csrf" value="{opts.csrf}"> <input type="text" name="duoreform{duoreform}" value="" style="display: none;"> <div if="{window.location.hash.match(/education/)}"> <h3>Choose Features Needed For Your Education Website</h3> <div each="{services}" if="{sectors.match(/education/)}" class="col-md-6 col-lg-4"> <formcheckbox label="{label}" name="{name}" width1="0" width2="12" onupdate="{parent.checked}"></formcheckbox> </div> </div> <div if="{window.location.hash.match(/web_apps/)}"> <h3>We\'re unable to give automated quotes for web apps.</h3> <p>Please enter your details in the form below and we will get back to you as soon as possible to discuss your requirements.</p> </div> <div if="{window.location.hash.match(/shopping/)}"> <h3>Choose Features Needed For Your Shopping Centre Website</h3> <div each="{services}" if="{sectors.match(/shopping/)}" class="col-md-6 col-lg-4"> <formcheckbox label="{label}" name="{name}" width1="0" width2="12" onupdate="{parent.checked}"></formcheckbox> </div> </div> <div if="{window.location.hash.match(/ecommerce/)}"> <h3>Choose Features Needed For Your Ecommerce Website</h3> <div each="{services}" if="{sectors.match(/ecommerce/)}" class="col-md-6 col-lg-4"> <formcheckbox label="{label}" name="{name}" width1="0" width2="12" onupdate="{parent.checked}"></formcheckbox> </div> </div> <div if="{window.location.hash.match(/membership/)}"> <h3>Choose Features Needed For Your Membership Website</h3> <div each="{services}" if="{sectors.match(/membership/)}" class="col-md-6 col-lg-4"> <formcheckbox label="{label}" name="{name}" width1="0" width2="12" onupdate="{parent.checked}"> </formcheckbox> </div> </div> <div if="{window.location.hash.match(/professional/)}"> <h3>Choose Features Needed For Your Membership Website</h3> <div each="{services}" if="{sectors.match(/professional/)}" class="col-md-6 col-lg-4"> <formcheckbox label="{label}" name="{name}" width1="0" width2="12" onupdate="{parent.checked}"> </formcheckbox> </div> </div> <hr> <div if="{window.location.hash.match(/education|shopping|ecommerce|membership|professional_services/)}"> <h4>Guide Price : £{price}.00</h4> <hr> </div> <div if="{window.location.hash.match(/education|shopping|ecommerce|membership|professional_services|web_apps/)}"> <h3>Your Details</h3> <div class="form-horizontal"> <input type="hidden" value="{price}" name="guide_price"> <forminput label="Your Name" name="name" isrequired></forminput> <forminput label="Organisation Name" name="org_name"></forminput> <forminput label="Email Adress" name="email" isrequired></forminput> <formtextarea label="Your Address" name="address" rows="4"></formtextarea> <forminput label="Postcode" name="postcode"></forminput> <forminput label="Telephone" name="tel"></forminput> <formtextarea label="Project Description (optional)" name="address" rows="9"></formtextarea> <div class="btn-toolbar"> <input type="submit" value="Send" class="btn btn-primary pull-right"> </div> </div><br> </div> </form> </div>', '', '', function(opts) {
this.baseprice = 3950;

this.duoreform = Math.round((4872987492 + new Date().getTime()) / 1000);

this.chosen = [];

this.services = [
  {
    label: "Event Calendar",
    name: "eventcal",
    price: 980,
    sectors: "education,membership,professional"
  }, {
    label: "Document Management",
    name: "document_management",
    price: 0,
    sectors: "education,membership,professional"
  }, {
    label: "Members Area",
    name: "members_area",
    price: 980,
    sectors: "education,membership,professional"
  }, {
    label: "Course Search",
    name: "course_search",
    price: 980,
    sectors: "education"
  }, {
    label: "Members Bulletin Board",
    name: "members_forum",
    price: 1225,
    sectors: "education,membership"
  }, {
    label: "Room Booking",
    name: "room_booking",
    price: 980,
    sectors: "education,membership"
  }, {
    label: "Google Map & Directions",
    name: "google_map",
    price: 490,
    sectors: "education,membership,shopping,professional"
  }, {
    label: "Social Media Integration",
    name: "social",
    price: 1225,
    sectors: "education,membership,shopping,ecommerce,professional"
  }, {
    label: "Responsive Web Design",
    name: "responsive",
    price: 980,
    sectors: "education,membership,shopping,ecommerce,professional"
  }, {
    label: "Editable Slideshow",
    name: "slideshow",
    price: 980,
    sectors: "education,membership,shopping,ecommerce,professional"
  }, {
    label: "Photo Gallery",
    name: "gallery",
    price: 490,
    sectors: "education,membership,shopping,ecommerce"
  }, {
    label: "Store Finder",
    name: "store_finder",
    price: 980,
    sectors: "shopping"
  }, {
    label: "Tennant List",
    name: "tennant_list",
    price: 1225,
    sectors: "shopping"
  }, {
    label: "Basket & Checkout System",
    name: "basket",
    price: 490,
    sectors: "ecommerce"
  }, {
    label: "Custom Invoices",
    name: "custom_invoices",
    price: 490,
    sectors: "ecommerce"
  }, {
    label: "Payment Gateway Integration",
    name: "payment_gateway",
    price: 490,
    sectors: "ecommerce"
  }, {
    label: "Distributor Search",
    name: "dist_search",
    price: 1225,
    sectors: "ecommerce"
  }, {
    label: "Offers System",
    name: "offers",
    price: 1470,
    sectors: "ecommerce"
  }, {
    label: "Members Area",
    name: "member_area",
    price: 1470,
    sectors: "membership,ecommerce"
  }, {
    label: "Postcode Search",
    name: "postcode_search",
    price: 1470,
    sectors: "membership,ecommerce"
  }, {
    label: "Members Contributed Content",
    name: "member_content",
    price: 980,
    sectors: "membership"
  }, {
    label: "Members discount system",
    name: "member_discounts",
    price: 490,
    sectors: "membership"
  }, {
    label: "Members Directory",
    name: "member_directory",
    price: 980,
    sectors: "membership"
  }
];

this.on('mount', function() {
  this.price = this.baseprice;
  return this.update();
});

this.on('update', function() {
  this.price = this.baseprice;
  this.chosen.forEach((function(_this) {
    return function(service) {
      return _this.price += service.price;
    };
  })(this));
  return this.price = (this.price + "").replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
});

this.sectorchange = (function(_this) {
  return function() {
    setTimeout(function() {
      return _this.update();
    });
    return true;
  };
})(this);

this.checked = (function(_this) {
  return function(obj, event) {
    var isChosen, service;
    service = (_this.services.filter(function(service) {
      return service.name === obj.name;
    }))[0];
    isChosen = _this.chosen.indexOf(service) > -1;
    if (obj.value && !isChosen) {
      _this.chosen.push(service);
    } else if (!obj.value && isChosen) {
      _this.chosen.splice(_this.chosen.indexOf(service), 1);
    }
    return _this.update();
  };
})(this);
});
    
  